import { Component, OnInit, Inject } from '@angular/core';
import {ChangePhoneModel} from '../../models/change-phone-model';
import {CustomersService} from '../../home/services/customers.service';
import {PHONE_MASK} from '../../helpers/format-helpers';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import {ToastService} from 'angular-toastify';

@Component({
  selector: 'app-change-customer-phone-dialog',
  templateUrl: './change-customer-phone-dialog.component.html',
  styleUrls: ['./change-customer-phone-dialog.component.css']
})
export class ChangeCustomerPhoneDialogComponent implements OnInit {



  constructor(
    public dialogRef: MatDialogRef<ChangeCustomerPhoneDialogComponent>,
    private customersService: CustomersService,
    private _toastService: ToastService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }
  public title = 'Change mobile number';
  public text = 'Enter the new mobile number to send a confirmation code to the customer';
  phoneMask = PHONE_MASK;



  public phone: number = null;
  public customerId: number;
  public pin: string = null;

  isPinDisabled = true;
  isLoading = false;

  ngOnInit() {

    if (this.data != null) {

      if ( this.data.title != null ) {
        this.title = this.data.title;
      }
      if ( this.data.text != null ) {
        this.text = this.data.text;
      }
      if ( this.data.customerId != null ) {
        this.customerId = this.data.customerId;
      }
    }
  }

  onConfirmClick(): void {

    const model = new ChangePhoneModel();
    model.phone = this.phone;
    model.customerId = this.customerId;
    model.code = this.pin;


    this.isLoading = true;

    this.customersService.confirmChangePhone(model).subscribe(result => {
      this._toastService.success('New mobile number confirmed.');
      this.isLoading = false;
      this.dialogRef.close(model);
    },
      error => {
        this.isLoading = false;
      }
    );


  }

  onYesClick(): void {

    const model = new ChangePhoneModel();
    model.phone = this.phone;
    model.customerId = this.customerId;

    this.isLoading = true;
    this.customersService.changePhone(model).subscribe(result => {
      this.isPinDisabled = false;
      this.isLoading = false;
      this._toastService.info('Code for verification sent.');
    },
      error => {
        this.isLoading = false;
      });

  }

  onNoClick(): void {

    if ( !this.isPinDisabled ) {
      this.isLoading = true;
      this.customersService.deleteChangePhone(this.customerId).subscribe(result => {
        this.isLoading = false;
        this._toastService.warn('Request deleted.');
      },
        error => {
          this.isLoading = false;
        });
    }

    this.dialogRef.close();
  }

}
